export default __webpack_public_path__ + "static/media/bg1.b812b06d.png";